import { hasValue } from 'swipeclock-frontend';

export default function transformer(evaluator) {
  function transform(topAppBar) {
    if (!hasValue(topAppBar)) {
      return null;
    }

    const newTopAppBar = topAppBar.reduce((prevList, item) => {
      return evaluator.checkIfTopAppBarItemIncluded(item)
        ? [...prevList, transformItem(item)]
        : prevList;
    }, []);

    return newTopAppBar;
  }

  function transformItem(item) {
    return {
      ...item,
      key: item.title.toLowerCase(),
    };
  }

  return {
    transform,
  };
}
